'use client';

import { moreLinks } from '@/constants';
import MoreDropdown from '../ui/MoreDropdown';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import LocaleSwitcher from './LocaleSwitcher';

export default function MenuMoreSection({ color }: { color: 'white' | 'black' }) {
    const t = useTranslations();

    const [isMoreOpen, setMoreOpen] = useState<boolean>(false);

    return (
        <>
            <MoreDropdown
                title={t('Buttons.more')}
                items={moreLinks(t)}
                orientation="right"
                color={color}
                onOpen={() => setMoreOpen(true)}
                onClose={() => setMoreOpen(false)}
            />
            {!isMoreOpen && <LocaleSwitcher color={color} />}
        </>
    );
}
